var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card" },
    [
      _c("div", { staticClass: "row p-3" }, [
        _c("div", { staticClass: "col-12 text-right" }, [
          _c(
            "a",
            { attrs: { href: _vm.SolutionViewFeatureGuideURL } },
            [
              _c("font-awesome-icon", {
                attrs: { icon: ["fas", "question-circle"] }
              }),
              _vm._v(" " + _vm._s(_vm.T.officialSolutionsInfo))
            ],
            1
          )
        ])
      ]),
      _vm.showSolution
        ? _c("omegaup-markdown", {
            attrs: {
              markdown: _vm.solution.markdown,
              "source-mapping": _vm.solution.sources,
              "image-mapping": _vm.solution.images
            }
          })
        : _c(
            "div",
            { staticClass: "interstitial" },
            [
              _c("omegaup-markdown", {
                attrs: { markdown: _vm.statusMessage }
              }),
              _c("omegaup-markdown", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showViewsLeft,
                    expression: "showViewsLeft"
                  }
                ],
                attrs: {
                  markdown: _vm.ui.formatString(_vm.T.solutionViewsLeft, {
                    available: _vm.allowedSolutionsToSee,
                    total: 5
                  })
                }
              }),
              _c("div", { staticClass: "text-center mt-5" }, [
                _vm.status === "unlocked"
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-md",
                        on: {
                          click: function($event) {
                            return _vm.$emit("get-solution")
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.T.wordsSeeSolution) + " "),
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "unlock"] }
                        })
                      ],
                      1
                    )
                  : _vm.status === "locked" &&
                    _vm.allowedSolutionsToSee === null
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary btn-md",
                        on: {
                          click: function($event) {
                            return _vm.$emit("get-allowed-solutions")
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.T.solutionAvailableViews) + " ")]
                    )
                  : _vm.status === "locked" && _vm.allowedSolutionsToSee > 0
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-md",
                        on: {
                          click: function($event) {
                            return _vm.$emit("unlock-solution")
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.T.wordsUnlockSolution) + " "),
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "lock"] }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }